export default __webpack_public_path__ + "static/media/lidar-services-international-inc.bdddb36e.png";